<h2>Documentos Gar-San</h2>
<tree-root #docsgen [focused]="true" [nodes]="this.nodesDocGenGarsan" [options]="this.options"></tree-root>
